// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.112.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.112.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.radar-icon {
	display: flex;
	align-items: center;
	justify-content: center;
}

.radar-circle {
	fill: url(#radarGradient);
	stroke: var(--palette-green-70);
	stroke-width: 4.5;
	opacity: 0.5;
}

.radar-sweep {
	stroke: var(--palette-green-70);
	stroke-width: 2.5;
	stroke-linecap: round;
	transform-origin: 50% 50%;
	animation: sweep 2s linear infinite;
	filter: drop-shadow(0 0 2px var(--palette-green-70));
	opacity: 0.5;
}

.radar-ping {
	fill: none;
	stroke: var(--palette-green-70);
	stroke-width: 3;
	transform-box: fill-box;
	transform-origin: 50% 50%;
	animation: ping 2s ease-out infinite;
	opacity: 0.5;
}

@keyframes sweep {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

@keyframes ping {
	0% {
		transform: scale(1);
		opacity: 0.5;
	}
	100% {
		transform: scale(7);
		opacity: 0;
	}
}
`, "",{"version":3,"sources":["webpack://./src/ui-library/AnimatedMarker.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;CACzB,+BAA+B;CAC/B,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,+BAA+B;CAC/B,iBAAiB;CACjB,qBAAqB;CACrB,yBAAyB;CACzB,mCAAmC;CACnC,oDAAoD;CACpD,YAAY;AACb;;AAEA;CACC,UAAU;CACV,+BAA+B;CAC/B,eAAe;CACf,uBAAuB;CACvB,yBAAyB;CACzB,oCAAoC;CACpC,YAAY;AACb;;AAEA;CACC;EACC,uBAAuB;CACxB;CACA;EACC,yBAAyB;CAC1B;AACD;;AAEA;CACC;EACC,mBAAmB;EACnB,YAAY;CACb;CACA;EACC,mBAAmB;EACnB,UAAU;CACX;AACD","sourcesContent":[".radar-icon {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.radar-circle {\n\tfill: url(#radarGradient);\n\tstroke: var(--palette-green-70);\n\tstroke-width: 4.5;\n\topacity: 0.5;\n}\n\n.radar-sweep {\n\tstroke: var(--palette-green-70);\n\tstroke-width: 2.5;\n\tstroke-linecap: round;\n\ttransform-origin: 50% 50%;\n\tanimation: sweep 2s linear infinite;\n\tfilter: drop-shadow(0 0 2px var(--palette-green-70));\n\topacity: 0.5;\n}\n\n.radar-ping {\n\tfill: none;\n\tstroke: var(--palette-green-70);\n\tstroke-width: 3;\n\ttransform-box: fill-box;\n\ttransform-origin: 50% 50%;\n\tanimation: ping 2s ease-out infinite;\n\topacity: 0.5;\n}\n\n@keyframes sweep {\n\t0% {\n\t\ttransform: rotate(0deg);\n\t}\n\t100% {\n\t\ttransform: rotate(360deg);\n\t}\n}\n\n@keyframes ping {\n\t0% {\n\t\ttransform: scale(1);\n\t\topacity: 0.5;\n\t}\n\t100% {\n\t\ttransform: scale(7);\n\t\topacity: 0;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
